import React, {Component} from 'react';
import {connect} from 'react-redux';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import {Card, Header, Form, Input} from 'semantic-ui-react';
import {dateFormatPicker, reverseShortDate} from '../../../common/constants/datesFormat';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {paths} from '../../../common/dictionaries/urls';
import {ORDERS_STATUS_COMPLETE} from './constants';
import {Actions} from '../../../common/actions';
import CardsByOrderType from './cardsByOrderType';
import './styles.scss';

const today = moment().format(reverseShortDate);

class KanbanLogistics extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'start': today,
      'end': today,
      'type': 'TO',
    };
  }

  componentDidMount() {
    if (!hasAccessPermission(this.props.permissions, resources.KanbanLogistics, scopes.See)) {
      this.props.navigateTo(paths.AccessDenied);
    }
    this.getOrders();
  }

  getOrders() {
    const {start, end, type} = this.state;
    this.props.getKanbanOrders({start, end, type});
  }

  handleChange = (format, field, value) => {
    this.setState({
      [field]: format === 'date' ? moment(value).format(reverseShortDate) : value,
    }, () => {
      this.getOrders();
    });
  }

  renderButtons() {
    return ORDERS_STATUS_COMPLETE.map((status) => {
      return (
        <button
          key={status.value}
          className='kanban-logistics-container__btn'
          onClick={() => this.handleChange('string', 'type', status.value)}
          style={{
            'border': `3px solid ${status.color.bg}`,
            'background': `${status.color.bg}`,
          }}
        >
          {status.text}{' '}
        </button>
      );
    });
  }

  render() {
    const {loading, orders, detail} = this.props;
    const {start, end} = this.state;

    return (
      <div className="kanban-logistics-container">
        <Card raised fluid >
          <div className="kanban-logistics-container__header">
            <Header as='h2'>Kanban Logística</Header>
            <div className='buttons__container'>
              {this.renderButtons()}
            </div>
            <div className="kanban-logistics-container__filter">
              <Form.Input fluid label="Fecha Inicial" className="kanban-logistics-label">
                <DatePicker
                  customInput={
                    <Input icon='calendar' size='small' />
                  }
                  placeholderText="Fecha incial"
                  className="kanban-logistics-datepicker"
                  selected={start ? moment(start, reverseShortDate).toDate() : null}
                  maxDate={moment(end, reverseShortDate).toDate()}
                  dateFormat={dateFormatPicker}
                  onChange={(value) => this.handleChange('date', 'start', value)}
                  locale='es'
                />
              </Form.Input>
              <Form.Input fluid label="Fecha Final" className="kanban-logistics-label">
                <DatePicker
                  customInput={
                    <Input icon='calendar' size='small' />
                  }
                  placeholderText="Fecha final"
                  className="kanban-logistics-datepicker"
                  selected={end ? moment(end, reverseShortDate).toDate() : null}
                  minDate={moment(start, reverseShortDate).toDate()}
                  dateFormat={dateFormatPicker}
                  onChange={(value) => this.handleChange('date', 'end', value)}
                  popperModifiers={{
                    'preventOverflow': {
                      'enabled': true,
                    },
                  }}
                  locale='es'
                />
              </Form.Input>
            </div>
          </div>
        </Card>

        <CardsByOrderType loading={loading} orders={orders} detail={detail}/>
        
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'permissions': state.session.permissions,
    'loading': state.kanbanLogistics.loading,
    'orders': state.kanbanLogistics.orders,
    'detail': state.kanbanLogisticsDetail.detail,
    'loadingDetail': state.kanbanLogisticsDetail.loading,
  };
};

const {getKanbanOrders, navigateTo} = Actions;

export default connect(mapStateToProps, {
  navigateTo,
  getKanbanOrders,
})(KanbanLogistics);
